export default "__VITE_PUBLIC_ASSET__1d2e20d8__"